var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileUrl)?_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticStyle:{"border":"1px solid #ccc","height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.fileUrl,"frameborder":"0"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }